module.exports = __webpack_public_path__ + "img/step1.a9a6a59f.svg";